module.exports = __webpack_public_path__ + "img/comp_turbine.868b1dd3.png";